export default class ReturnedItem
{
    constructor (data = null)
    {
        if (data !== null)
        {
            // productCode in DB
            this.StyleNumber = this.GetCellString(data.getCell(2));
            this.ProductName = this.GetCellString(data.getCell(3));
            this.DamageCategory = this.GetCellString(data.getCell(4));
            this.Remark = this.GetCellString(data.getCell(5));
        }
    }

    GetCellString(cell)
    {
        if (cell.value === null || cell.value === undefined)
        {
            return null;
        }

        return cell.value.toString().trim();
    }
}